import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { PageLoaderService } from '../../../../lib/ng2-sapmp/src/ui-components/page-loader';
import { BreadCrumbModel, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components';
import { BREADCRUMBS } from 'config';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray} from '@angular/forms';
import { ManageInventoryService} from './../shared';
import { KEY_CONFIG } from 'lib/ng2-sapmp/src/config/key-config';


@Component({
  selector: 'app-managenotifications',
  templateUrl: './managenotifications.component.html',
  styleUrls: ['./managenotifications.component.scss'],
  providers: [ManageInventoryService]
})


export class ManagenotificationsComponent implements OnInit {

  constructor(private route: ActivatedRoute, private router: Router,private utilityService: UtilityService,
    private pageloaderService: PageLoaderService, private breadcrumb: BreadCrumbService,
    private formBuilder: FormBuilder,private manageInventoryService: ManageInventoryService) {
     
      
     }

  notificationdata:any;
  formSuccess = false;
  notifychecklistdata:any;
  failuremessage:boolean = false;
  dataloadError: boolean= false;
  dataloadsuccess:boolean=false;
  selectedbox;
  fan:any;
  existingroute:any;
  profileid:any;
  notifyenablestatus:any;
  notifyenablestatusdeviceinventory:any;
  isTextMessage: boolean = false;

  ngOnInit() {
   
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.notificationdata = this.route.snapshot.data.pageData.manageInventorymanagenotification;
    console.log(this.notificationdata);
    console.log(this.notificationdata.cartoonsData);
    this.notifychecklistdata = this.notificationdata.cartoonsData;
    console.log(this.notifychecklistdata.cartoon);
    this.pageLoad();
    
    this.existingroute = sessionStorage.getItem("currentRoute");

    if(this.existingroute === '/manageInventory/deviceInventory'){
      this.fan = sessionStorage.getItem("fanID");
      console.log(this.fan);
    }
    else if(this.existingroute === '/manageInventory'){
      this.fan = sessionStorage.getItem("profileFAN");
      console.log(this.fan);
    } 

    if(this.existingroute === '/manageInventory'){
    this.notifyenablestatus = sessionStorage.getItem("NotificationStatus");
      console.log(this.notifyenablestatus);
      if(this.notifyenablestatus === ": Text"){
          this.checkedItems[1].checked = true;    
      }else if(this.notifyenablestatus === ": Email"){
         this.checkedItems[0].checked = true;
      }else if(this.notifyenablestatus === ": Email/Text"){
        this.checkedItems[0].checked = true;
        this.checkedItems[1].checked = true; 
     }
      else{
         this.checkedItems[0].checked = false;
         this.checkedItems[1].checked = false; 
      }
    }
    else if(this.existingroute === '/manageInventory/deviceInventory'){ 
      this.notifyenablestatusdeviceinventory = sessionStorage.getItem("Notifystatusdeviceinventory");
      if(this.notifyenablestatusdeviceinventory === "Text"){
        this.checkedItems[1].checked = true;    
        }else if(this.notifyenablestatusdeviceinventory === "Email"){
          this.checkedItems[0].checked = true;
        }else if(this.notifyenablestatusdeviceinventory === "Email/Text"){
          this.checkedItems[0].checked = true;
          this.checkedItems[1].checked = true; 
      }
        else{
          this.checkedItems[0].checked = false;
          this.checkedItems[1].checked = false; 
        }
    }

  }

  changeEvent($event) {
    if (this.checkedItems[0].checked || this.checkedItems[1].checked) {
        this.selectedbox= true;
    }else {
        this.selectedbox= false;
    }
   
  }
  

  nestedjson = [
    { name: "Email",  checked: false },
    { name: "Text Messages", checked: false },
   ];

  checkedItems = this.nestedjson.map(x => ({ name: x.name, checked: false }));

  //  textObj = JSON.parse('nestedjson');
  //  if(textObj.name ==)
  
 
  
submit(){
  this.pageloaderService.setPageLoaderStatus(false);
  let checkboxdata = this.checkedItems;
  console.log(checkboxdata);
  let emaildata = checkboxdata[0].checked;
  let smsdata = checkboxdata[1].checked;
    console.log(emaildata);
    console.log(smsdata);
  // let profileid = sessionStorage.getItem('profileId');
  //   console.log(profileid);
  
    if(this.existingroute === '/manageInventory/deviceInventory'){
      this.profileid = sessionStorage.getItem('profileId');
      console.log(this.profileid);
    }
    else if(this.existingroute === '/manageInventory'){
      this.profileid = sessionStorage.getItem('NotificationprofileID');
      console.log(this.profileid);
    } 
    
  let checkdata ={
      "emailEnabled": emaildata.toString(),
      "smsEnabled": smsdata.toString(),
      "fan": this.fan
    }

    if (this.utilityService.getEnvConfig().useMock) {

      if(this.existingroute === '/manageInventory/deviceInventory'){
            
        this.router.navigate(['/manageInventory/deviceInventory']);
        sessionStorage.setItem('resSuccess','true'); 
      }
      else if (this.existingroute === '/manageInventory'){
       
        this.router.navigate(['/manageInventory']);
        sessionStorage.setItem('resSuccess','true');
      } 
      else {
        sessionStorage.setItem('resSuccess','false');
        this.failuremessage = true;
      }
      this.pageloaderService.setPageLoaderStatus(true);
    } else {
      this.manageInventoryService.postchecklistdata(checkdata)
      .subscribe(
      res => {
          if(this.existingroute === '/manageInventory/deviceInventory'){
            
            this.router.navigate(['/manageInventory/deviceInventory']);
            sessionStorage.setItem('resSuccess','true'); 
          }
          else if(this.existingroute === '/manageInventory'){
           
            this.router.navigate(['/manageInventory']);
            sessionStorage.setItem('resSuccess','true');
          //  this.formSuccess = true;
            console.log(res);
          } 
          else{
            sessionStorage.setItem('resSuccess','false');
            this.failuremessage = true;
          }
          this.pageloaderService.setPageLoaderStatus(true);
      }), error => {
        //  alert("error");
        this.pageloaderService.setPageLoaderStatus(true);
         this.failuremessage = true;
       };
    }
    
}

  pageLoad() {
    const breadcrumb = new BreadCrumbModel();
    breadcrumb.label = this.notificationdata.fanBreadcumb;
    breadcrumb.routerLink = this.notificationdata.fanBreadcrumbRoute;
    this.breadcrumb.setCurrentBreadCrumb(breadcrumb);
  }

  toggleTooltipEnter(event) {
    if (event.type !== 'mouseenter') {
      if (event.keyCode !== KEY_CONFIG.enter) {
        return;
      }
    }
    let targetElement = event.target;
    const elems = document.querySelectorAll('.tooltipActive');
    let iselementActive = false;
    if (targetElement.classList.contains('tooltipActive')) {
      iselementActive = true;
    }
    [].forEach.call(elems, function (ele) {
      ele.classList.remove('tooltipActive');
    });
    if (iselementActive) {
      targetElement.classList.remove('tooltipActive');
    } else {
      targetElement.classList.add('tooltipActive');
    }
  }

  toggleTooltipLeave(event) {
    if (event.type !== 'mouseleave') {
      if (event.keyCode !== KEY_CONFIG.enter) {
        return;
      }
    }
    let targetElement = event.target;
    const elems = document.querySelectorAll('.tooltipActive');
    let iselementActive = false;
    if (targetElement.classList.contains('tooltipActive')) {
      iselementActive = true;
    }
    [].forEach.call(elems, function (ele) {
      ele.classList.remove('tooltipActive');
    });
    if (iselementActive) {
      targetElement.classList.remove('tooltipActive');
    } else {
      targetElement.classList.add('tooltipActive');
    }
  }










}

